import { useEffect, useState } from 'react'
import * as Yup from "yup";
import { Button, Col, Form, Row } from 'reactstrap';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomPhoneNumberBox } from 'components/shared/CustomPhoneNumberBox';
import { CustomEmailBox } from 'components/shared/CustomEmailBox';
import { useFormik } from 'formik';
import { CustomToaster } from 'components/shared/CustomToaster';
import CommonService from 'services/CommonService';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import { IGetBecomeAPartner } from 'models/IGetBecomeAPartner';
import CustomLoader from 'components/Common/CustomLoader';
import { HelperConstant } from '../../helpers/HelperConstant';
import { IStatusModel } from 'models/StatusModel';
import { isIn } from '../../helpers/Helper';

type Props = {
    setEditModel?: any,
    Id?: any,
    requestData(pageNumber: any, searchText: any, statusid: any, sortcolumn?: string, sortorder?: string): any,
    statusId: any,
    statusList: Array<any>
}

function BecomeAPartnerPopUp({ setEditModel, Id, requestData, statusId, statusList }: Props) {

    const [showToastUpdate, setShowToastUpdate] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [becomeapartnerData, setbecomeapartnerData] = useState<IGetBecomeAPartner | null>(null);
    const [showLoading, setShowLoading] = useState(true);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            CompanyName: "",
            ContactPersonName: "",
            EmailId: "",
            Experience: "",
            MobilePhone: "",
            State: "",
            District: "",
            Comments: "",
            StatusId: 0,
        },
        validationSchema: Yup.object({
            CompanyName: Yup.string().required("Please Enter CompanyName").nullable(),
            ContactPersonName: Yup.string().required("Please Enter ContactPersonName").nullable(),
            EmailId: Yup.string().required("Please Enter Email").nullable(),
            Experience: Yup.string().required("Please Enter Experience").nullable(),
            Comments: Yup.string().required("Please Enter Comments").nullable(),
            State: Yup.string().required("Please Enter State").nullable(),
            District: Yup.string().required("Please Enter District").nullable(),
            MobilePhone: Yup.string().required("Please Enter Valid Mobile Number").matches(isIn() ? HelperConstant.phonenumberPattern.pattern : HelperConstant.UAEPhonenumberPattern.pattern, "Please Enter Valid Mobile Number").nullable(),
        }),

        onSubmit(values) {
            return onUpdate(values as any);
        },
    })

    const onUpdate = (data: IGetBecomeAPartner) => {
        setbecomeapartnerData(data);
        setDisabled(true);
        CommonService.post('Partner', 'Edit', data).then((res: any) => {
            if (res.status == 200) {
                setEditModel(false);
                requestData(0, "", statusId, "desc", "modified");
            }
            setDisabled(false);
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const onGetBecomeAPartner = () => {
        setShowLoading(true);
        CommonService.getWithSingleEntity('Partner', 'View', Id).then((res: any) => {
            if (res.status == 200) {
                formik.setValues({ ...res.data });
                setbecomeapartnerData(res.data);
            }
            setShowLoading(false);
        }).catch((e: string) => {
            console.log(e);
            setShowLoading(false);
        });
    }

    const UpdatePartnerApproved = () => {
        setDisabled(true);
        CommonService.post('Partner', 'UpdatePartnerApproved', becomeapartnerData).then((res: any) => {
            if (res.status == 200) {
                setEditModel(false);
                requestData(0, "", statusId, "desc", "modified");

            }
            setDisabled(false);
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const UpdatePartnerRejected = () => {
        setDisabled(true);
        CommonService.post('Partner', 'UpdatePartnerRejected', becomeapartnerData).then((res: any) => {
            if (res.status == 200) {
                setEditModel(false);
                requestData(0, "", statusId, "desc", "modified");

            }
            setDisabled(false);
        }).catch((e: string) => {
            console.log(e);
        });
    }
    useEffect(() => {
        onGetBecomeAPartner();
    }, []);

    return (
        <div className="fl_content-style px-2">
            {showLoading && <CustomLoader isOpen={showLoading} />}
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Row>
                    <Col xl={4}>
                        <CustomTextBox
                            name="CompanyName"
                            label="Company Name"
                            id={"CompanyName"}
                            value={formik.values.CompanyName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.CompanyName && formik.errors.CompanyName ? true : false}
                            error={formik.errors.CompanyName}
                            onChange={formik.handleChange}
                            placeholder={"CompanyName"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={4}>
                        <CustomTextBox
                            name="ContactPersonName"
                            label="Contact Person Name"
                            id={"ContactPersonName"}
                            value={formik.values.ContactPersonName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.ContactPersonName && formik.errors.ContactPersonName ? true : false}
                            error={formik.errors.ContactPersonName}
                            onChange={formik.handleChange}
                            placeholder={"ContactPersonName"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={4}>
                        <CustomTextBox
                            name="Experience"
                            label="Experience"
                            id={"Experience"}
                            value={formik.values.Experience}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Experience && formik.errors.Experience ? true : false}
                            error={formik.errors.Experience}
                            onChange={formik.handleChange}
                            placeholder={"Experience"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomEmailBox
                            name="EmailId"
                            label="Email"
                            id={"EmailId"}
                            value={formik.values.EmailId}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.EmailId && formik.errors.EmailId ? true : false}
                            error={formik.errors.EmailId}
                            onChange={formik.handleChange}
                            placeholder={"Email"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomPhoneNumberBox
                            name="MobilePhone"
                            label="Phone Number"
                            id={"MobilePhone"}
                            value={formik.values.MobilePhone}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.MobilePhone && formik.errors.MobilePhone ? true : false}
                            error={formik.errors.MobilePhone}
                            onChange={formik.handleChange}
                            placeholder={"+91 9087654321"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="State"
                            label="State"
                            id={"State"}
                            value={formik.values.State}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.State && formik.errors.State ? true : false}
                            error={formik.errors.State}
                            onChange={formik.handleChange}
                            placeholder={"State"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="District"
                            label="District"
                            id={"District"}
                            value={formik.values.District}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.District && formik.errors.District ? true : false}
                            error={formik.errors.District}
                            onChange={formik.handleChange}
                            placeholder={"District"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={12}>
                        <CustomTextArea
                            name="Comments"
                            label="Comments"
                            id={"Comments"}
                            value={formik.values.Comments}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Comments && formik.errors.Comments ? true : false}
                            error={formik.errors.Comments}
                            onChange={formik.handleChange}
                            placeholder={"Comments"}
                            isMandatory={false}
                        />
                    </Col>
                    {/* <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <CustomTextBox
                            name="Comments"
                            label="Comments"
                            id={"Comments"}
                            value={formik.values.Comments}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Comments && formik.errors.Comments ? true : false}
                            error={formik.errors.Comments}
                            onChange={formik.handleChange}
                            placeholder={"Comments"}
                            isMandatory={false}
                        />
                    </Col> */}

                </Row>
                <Row>
                    <Col className='text-end mt-3'>
                        <Button className='btn btn-secondary m-2' type='button' onClick={() => { setEditModel(false); }}>Cancel</Button>
                        <Button className='btn btn-success m-2' type='submit' disabled={disabled}>Update</Button>
                        <Button className='btn btn-warning m-2' type='button' disabled={disabled} onClick={UpdatePartnerApproved}>Approved</Button>
                        <Button className='btn btn-danger m-2' type='button' disabled={disabled} onClick={UpdatePartnerRejected}>Reject</Button>
                        {/* <Button className='btn btn-light' type='button' disabled={disabled}>Convert To Vendor</Button> */}
                    </Col>
                </Row>
            </Form>
            <Row>
                <CustomToaster message={'Your delay response have been saved.'} color={'text-success'} toast={showToastUpdate} setToast={setShowToastUpdate} />
            </Row>
        </div>
    )
}

export default BecomeAPartnerPopUp